module.exports = require("@swa-ui/placements/src/ListBlockPlacement/ListBlockPlacement.module.scss");